import { WEBVIEW_TYPE_ENTRY } from '@/constants/entry';
import { useDeviceInfoStore, WEBVIEW_TYPE } from '@/stores/DeviceStore';

/**
 * api에 entry를 간편히 보내기 위한 훅\
 * TOSS 또는 KB_PAY에서 왔을 경우 다른 데이터를 보여주기 위한 목적으로 사용
 */
export const useWebviewTypeEntry = () => {
  const [isKbWebview, isTossWebview, webviewType] = useDeviceInfoStore(
    (state) => [
      state.webviewType === WEBVIEW_TYPE.KB_PAY,
      state.webviewType === WEBVIEW_TYPE.TOSS,
      state.webviewType,
    ],
  );

  const entry: WEBVIEW_TYPE_ENTRY = (() => {
    if (isKbWebview) return WEBVIEW_TYPE_ENTRY.KB_PAY;
    if (isTossWebview) return WEBVIEW_TYPE_ENTRY.TOSS;

    return WEBVIEW_TYPE_ENTRY.WELLO;
  })();

  //* webviewType이 실제로 결정되었는지 여부(undefined 등 초기 상태는 false)
  const hasWebviewType = !!webviewType;

  return {
    entry,
    hasWebviewType,
  };
};
